import { render, staticRenderFns } from "./modalHistorial.vue?vue&type=template&id=355d4f74&scoped=true"
import script from "./modalHistorial.vue?vue&type=script&lang=js"
export * from "./modalHistorial.vue?vue&type=script&lang=js"
import style0 from "./modalHistorial.vue?vue&type=style&index=0&id=355d4f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355d4f74",
  null
  
)

export default component.exports